






















































































import { Component, PropSync, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { email, requiredIf } from 'vuelidate/lib/validators';
import vSelect from 'vue-select';
import { Address, OrgsApi, UsersApi } from '../../api';
import Toast from '@/components/display/toast.vue';
import adminSuggest from '@/components/form pickers/adminSuggest.vue';
import { AxiosResponse } from 'axios';
import { Organisation } from '@/models/organisation';
import UserPhoneInput from '@/components/form pickers/UserPhoneInput.vue';
import { PhoneNumberDetails } from '@/models/phone-number-details';

@Component({
	components: {
		UserPhoneInput,
		vSelect,
		Toast,
		adminSuggest,
	},
	validations: {
		localOrg: {
			id: {
				required: requiredIf(function() {
					return !this.localOrg.id;
				}),
			},
			admin: {
				name: {
					required: requiredIf(function() {
						return !this.localOrg.adminId;
					}),
				},
				email: {
					required: requiredIf(function() {
						return this.emailRequired && !this.localOrg.adminId;
					}),
					email,
				},
				// minLength: minLength(7), numeric
			},
		},
	},
	mixins: [validationMixin],
})
export default class AddOrgAdmin extends Vue {
	public existingSite = false;
	public emailRequired = true;
	public billingRequired = true;
	public loading = false;
	public $bvToast: any;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public region: any = null;
	public siteRegion: any = null;
	public phoneValid = true;

	@PropSync('org') public localOrg!: Organisation;

	public isValid(field) {
		return field && field.$dirty ? !field.$invalid : null;
	}

	public stepValidate(name: string) {
		const form = this.$v[name];
		form.$touch();
		if (!form.$invalid) {
			this.onComplete();
		}
	}

	public async onComplete(...a: any[]) {
		this.submitStatus = 'PENDING';
		if (!this.localOrg.adminId && !!this.localOrg.admin.id) {
			try {
				const promise = await new OrgsApi().updateOrg(parseInt(this.localOrg.id, 10), {
					data: { adminId: this.localOrg.admin.id },
				});
				this.localOrg.adminId = promise.data.id;
			} catch (e) {
				let error;
				if (e.response) {
					if (e.response.data.message) {
						error = 'user not added ' + e.response.data.message;
					} else {
						error = 'user not added unknown error, check response';
					}
				} else if (e.request) {
					// console.log(e.request);
					error = 'user not added, network Error';
				} else {
					// console.log("unknown Error");
					error = 'user not added, unknown Error';
				}
				// const error = e.response.data.errors.name[0];
				new Toast().makeToast(error, 'Error Adding User', 'danger', true);
				this.submitStatus = 'ERROR';
				return;
			}
		} else {
			try {
				const promise = await new UsersApi().createUser({
					data: {
						name: this.localOrg.admin.name,
						email: this.localOrg.admin.email,
						phone: this.localOrg.admin.phone,
						orgId: this.localOrg.id,
						role: 'org.admin',
					},
				});

				await new OrgsApi().updateOrg(parseInt(this.localOrg.id, 10), {
					data: { adminId: promise.data.data.id },
				});
				this.localOrg.adminId = promise.data.data.id;
				this.localOrg.admin.id = promise.data.data.id;
			} catch (e) {
				let error;
				if (e.response) {
					if (e.response.data.message) {
						error = 'user not created ' + e.response.data.message;
					} else {
						error = 'user not created unknown error, check response';
					}
				} else if (e.request) {
					// console.log(e.request);
					error = 'user not created, network Error';
				} else {
					// console.log("unknown Error");
					error = 'user not created, unknown Error';
				}
				// const error = e.response.data.errors.name[0];
				new Toast().makeToast(error, 'Error Adding user', 'danger', true);
				this.submitStatus = 'ERROR';
				return;
			}
		}

		try {
			await this.createOrdwayContact(
				this.localOrg.admin.name,
				parseInt(this.localOrg.id, 10),
				parseInt(this.localOrg.admin.id, 10),
				this.localOrg.admin.email,
				this.localOrg.admin.phone,
			);
		} catch (e) {
			new Toast().makeToast(
				'There was an error creating this contact in Ordway. Please retry / let the software team know',
				'Error creating Ordway Contact',
				'danger',
				true,
			);
			return;
		}

		this.submitStatus = 'OK';
		new Toast().makeToast('User added to Org', 'User Added', 'success');
		this.$emit('nextTab');
		this.$emit('load');
	}

	private async createOrdwayContact(
		contactName: string,
		orgId: number,
		userId: number,
		userEmail: string,
		phone: string,
	): Promise<AxiosResponse<any>> {
		let address: Address;
		if (Array.isArray(this.localOrg.address)) {
			address =
				this.localOrg.address.find(x => x.type === 'postal') ||
				this.localOrg.address.find(x => x.type === 'street');
		} else {
			address = this.localOrg.address;
		}
		const contactCreateResponse = await this.axios.patch(
			process.env.VUE_APP_API_URL.replace(/\/+$/, '') + '/ordway/contact/updateDefault',
			{
				displayName: contactName,
				levnoOrgId: orgId,
				levnoUserId: userId,
				email: userEmail,
				phone,
				address: address.fullAdr,
			},
		);
		return contactCreateResponse;
	}

	public onPhoneChanged(params: { phone: string; phoneObject: PhoneNumberDetails }): void {
		if (params.phoneObject.valid === true) {
			this.phoneValid = true;
			const { countryCallingCode, nationalNumber } = params.phoneObject;
			this.localOrg.admin.phone = `+${countryCallingCode} ${nationalNumber}`;
			return;
		} else if (params.phone === '') {
			this.localOrg.admin.phone = null;
		}
		this.phoneValid = false;
	}
}
